import client from 'utils/contentfulService';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const getLinks = async (key, params) => {
  const { clientId, ctfLocaleFilter, insuranceTags } = params;

  try {
    const ctfPayload = {
      content_type: 'link',
      'fields.client.sys.id': clientId,
      'fields.reviewStatus': 'Accepted',
      'fields.show[in]': 'Home',
      order: '-fields.homeOrder',
      ...ctfLocaleFilter,
    };

    if (!_isEmpty(insuranceTags)) {
      ctfPayload['fields.tags.sys.id[in]'] = insuranceTags
        .map(item => item.id)
        .join(',');
    }

    const response = await client.getEntries(ctfPayload);
    const items = _get(response, 'items', []);

    const prettyData = [];
    items.forEach(item => {
      const {
        fields: {
          callToAction,
          image,
          url,
          slug,
          reviewStatus,
          subtitle,
          title,
          homeOrder,
          exitDisclaimer,
        },
        sys,
      } = item;
      prettyData.push({
        callToAction,
        image,
        url,
        slug,
        reviewStatus,
        shortDescription: subtitle,
        sys,
        name: title,
        homeOrder,
        exitDisclaimer,
      });
    });
    return prettyData;
  } catch (error) {
    throw new Error(error);
  }
};

export default getLinks;
